import { render } from "./CharacterIndex.vue?vue&type=template&id=71147772&scoped=true"
import script from "./CharacterIndex.vue?vue&type=script&lang=js"
export * from "./CharacterIndex.vue?vue&type=script&lang=js"

import "./CharacterIndex.vue?vue&type=style&index=0&id=71147772&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-71147772"

export default script